import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Grab the token from the storage and ensure it is set
        const authStr = localStorage.getItem('cbs-session-token') || '{}';
        const authResult = JSON.parse(authStr);
        if (authResult.token != null) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${authResult.token}`,
                    IsDash: '1',
                    Community: localStorage.getItem('curr_community') || ''
                }
            });
        } else {
            // at least pass up that this is from dashboard
            request = request.clone({
                setHeaders: {
                    IsDash: '1'
                }
            });
        }
        return next.handle(request);
    }
}
